import { Controller } from 'react-hook-form';
import RadioButton from '@/components/radioButtonSel';

function RadioButtonController(props) {
  const {
    className = '',
    inputName,
    inputId,
    control,
    rules = {},
    options,
    handleOnChange = () => {},
    defaultValue = '',
    label = '',
    disabled = false,
    handleOnSelect = null,
    selectValue = null,
  } = props;
  return (
    <Controller
      name={inputId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, name, value },
        fieldState: { error },
      }) => (
        <RadioButton
          className={className}
          id={inputId}
          name={inputName}
          error={error?.message || ''}
          onChange={(event) => {
            onChange(event);
            handleOnChange({ label: name, value: event });
          }}
          onBlur={onBlur}
          options={options}
          optionSelected={value}
          defaultValue={defaultValue}
          label={label}
          disabled={disabled}
          handleOnSelect={handleOnSelect}
          selectValue={selectValue}
          {...props}
        />
      )}
    />
  );
}

export default RadioButtonController;
